import { useAxios } from '../Plugins/axios';
import { useSpinner } from '../Plugins/spinner';
import { useRoute } from '../Plugins/ziggy';
export default class SymptomRecordService {
    axios;
    route;
    spinner;
    constructor() {
        this.axios = useAxios();
        this.route = useRoute();
        this.spinner = useSpinner();
    }
    getById(id) {
        return this.axios
            .get(this.route('api.symptom-records.show', [id]))
            .then((response) => {
            const data = response.data.data;
            this.processSymptomRecordValues(data);
            return data;
        });
    }
    save(formData, id) {
        let url = id
            ? this.route('api.symptom-records.update', [id])
            : this.route('api.symptom-records.store');
        this.spinner.show();
        return this.axios
            .post(url, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        })
            .then((res) => {
            const data = this.processSymptomRecordValues(res.data.data);
            return data;
        })
            .catch((err) => {
            console.log(err);
        })
            .finally(() => {
            this.spinner.hide();
        });
    }
    processSymptomRecordValues(symptomRecord) {
        symptomRecord.symptom_record_values.forEach((value) => {
            if (value.symptom.type === 'bool') {
                value.value = value.value === '1' ? true : false;
            }
            else if (value.symptom.type === 'enum' &&
                value.symptom.multiple) {
                value.value = value.value.split(',');
            }
        });
        return symptomRecord;
    }
}
